import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import HeaderComic from "../../components/comic/HeaderComic";
import InfoMovie from "../../components/movie/InfoMovie";
import ListCount from "../../components/movie/ListCount";
import OptionMovie from "../../components/movie/OptionMovie";
import Header from "../../components/ui/Header";
import RelatedPosts from "../../components/ui/RelatedPosts";
import { useEpisodes } from "../../hooks/useEpisodes";
import { usePostDetails } from "../../hooks/usePost";
import Footer from "../../components/layout/Footer";
import { postApi } from "../../services/api/postApi";
import EpisodeList from "../../components/movie/EpisodeList";

const NovelDetail: React.FC = () => {
  const { slug, lang } = useParams<{ slug: string; lang: string }>();
  const location = useLocation();
  const [novel, setNovel] = useState(location.state?.item || null);
  const [page, setPage] = useState(1);
  const { data: fetchedNovel } = usePostDetails(slug || "", "novel");
  const [descExpanded, setDescExpanded] = useState(false);
  const [isReading, setIsReading] = useState(false);
  const navigate = useNavigate();

  const { episodes: rawChapters, isLoading, hasNextPage } = useEpisodes(
    "novel",
    novel?.id || "",
    slug || "",
    page
  );

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  useEffect(() => {
    if (location.state?.item) {
      setNovel(location.state.item);
    } else {
      setNovel(null);
    }
    window.scrollTo(0, 0);
    setDescExpanded(false);
    setIsReading(false);
  }, [slug, location.state]);

  const handleReadChapter = (chapterId?: string) => {
    if (!chapterId) return;
    const chapter = rawChapters.find(
      (c: any) => String(c.id) === String(chapterId)
    );
    console.log(`Navigating to chapter: ${chapterId}`, chapter, rawChapters);
    if (!chapter) return;
    navigate(`/${lang}/novel/${novel.slug}/${chapter.index}/`, {
      state: {
        detail: novel,
        chapters: rawChapters,
      },
    });
  };

  useEffect(() => {
    if (fetchedNovel) {
      setNovel(fetchedNovel);
      // Track view after fetching novel details
      if (fetchedNovel.id) {
        postApi
          .trackPostView("novel", fetchedNovel.id)
          .then(() => console.log("View tracked successfully"))
          .catch((err) => console.error("Error tracking view:", err));
      }
    }
  }, [fetchedNovel]);

  if (!novel) {
    return (
      <div className="novel-details bg-mainBlack">
        <h1 className="text-2xl">Không tìm thấy truyện</h1>
      </div>
    );
  }

  return (
    <div className="novel-details bg-mainBlack text-white min-h-screen w-full">
      <Header isBack />
      <div className="relative">
        <HeaderComic
          title={novel?.title || ""}
          banner={novel.banner || novel.feature || ""}
          genre={novel?.categories?.map((cat: any) => cat.name) || []}
          type="novel"
          rating={novel?.rating_avg || 0}
          loading={isLoading}
          onPlay={handleReadChapter}
          firstChapterId={
            rawChapters.length > 0 && rawChapters[0]?.index
              ? String(rawChapters[0].index)
              : undefined
          }
          lastChapterId={
            rawChapters.length > 1 && rawChapters[rawChapters.length - 1]?.index
              ? String(rawChapters[rawChapters.length - 1].index)
              : undefined
          }
          episodeTotal={rawChapters?.length || 0}
          likeCount={novel.like_count}
          author={novel.author || ""}
        />
      </div>
      <div className="px-1 md:px-0">
        <div className="md:hidden">
          <ListCount
            episodeTotal={rawChapters?.length || 0}
            likeCount={novel.like_count}
            ratingAvg={novel.rating_avg}
          />
        </div>
        <EpisodeList
          currentVideoUrl={""}
          episodes={rawChapters || []}
          movieSlug={novel.slug}
          onPlayEpisode={handleReadChapter}
          type="novel"
          isNext={hasNextPage}
          page={page}
          onPageChange={handlePageChange}
        />
        <OptionMovie
          episodeTotal={novel.episode_total}
          likeCount={novel.like_count}
          ratingAvg={novel.rating_avg}
          onPlay={() => setIsReading(true)}
          isPlaying={isReading}
          post={novel}
        />
        <InfoMovie
          releaseYear={novel.release_year || []}
          categories={novel.categories || []}
          directors={novel.directors || []}
          actors={novel.actors || []}
          description={novel.description || ""}
          descExpanded={descExpanded}
          setDescExpanded={setDescExpanded}
        />
      </div>
      <RelatedPosts
        postId={novel.id}
        postType="novel"
        title={novel.related_post?.button.label || "Truyện liên quan"}
      />
      <Footer />
    </div>
  );
};

export default NovelDetail;
